/* Imports */
import '../bootstrap/scripts';
import '../scss/main.scss';
import 'lazysizes';
import 'slick-carousel/slick/slick';
require('./template-images');
// var WebFont = require('webfontloader');
// Necessary for IE11...
require('picturefill');
require('svgxuse');

/* Load fonts via Google Fonts */
// WebFont.load({
//     google: {
//         families: ['Source Sans Pro', 'Montserrat']
//     }
// });

/* Custom scripts */
$(document).ready(function(){
    $('.js-logo-slider ').slick({
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 6,
        prevArrow: '.js-prev-arrow',
        nextArrow: '.js-next-arrow',
        responsive: [
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    });

    // document.querySelector('.js-button--play').addEventListener('click', () => document.querySelector('.js-audio-file').play());
    //
    // $('.js-sponsors').slick({
    //     autoplay: true,
    //     lazyLoad: 'ondemand',
    //     arrows: false,
    //     dots: true,
    //     slidesToShow: 4,
    //     slidesToScroll: 4,
    //     responsive: [
    //         {
    //             breakpoint: 1024,
    //             settings: {
    //                 slidesToShow: 4,
    //                 slidesToScroll: 4,
    //                 infinite: true,
    //                 dots: true
    //             }
    //         },
    //         {
    //             breakpoint: 980,
    //             settings: {
    //                 slidesToShow: 3,
    //                 slidesToScroll: 3
    //             }
    //         },
    //         {
    //             breakpoint: 480,
    //             settings: {
    //                 slidesToShow: 2,
    //                 slidesToScroll: 2
    //             }
    //         }
    //     ]
    // });

});



// WEBPACK FOOTER //
// ./craft/templates/src/js/main.js